import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { of, Observable } from "rxjs";
import {
  map,
  startWith,
  filter as rxFilter,
  debounceTime,
  distinctUntilChanged,
} from "rxjs/operators";
import { UntypedFormControl, Validators } from "@angular/forms";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { MatRadioChange } from "@angular/material/radio";
import { MatButtonToggleChange } from "@angular/material/button-toggle";

// SERVICES
import { EndpointService } from "../../../services/generic/endpoint.service";
import { GenericService } from "../../../services/generic/generic.service";
import { Dispatcher } from "app/services/dispatcher";
import { FunctionsService } from "../../../services/generic/functions.service";
import { FunctionsControllerService } from "../../../services/generic/functions-controller.service";
import { ConditionsClientService } from "app/services-client/conditions-client.service";

@Component({
  selector: "app-selection",
  templateUrl: "./selection.component.html",
  styleUrls: ["./selection.component.css"],
})
export class SelectionComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() structure: any;
  @Input() index: number;
  genericForm: any;

  public options: any;
  public idQuery: number;
  public optionsAuto: string[] = [];
  public optionsAutoMap: Map<string, number>;
  public optionsAutoMapGroup: Map<string, any>;
  public optionsAutoMapColors: Map<string, any>;

  /** Cache de normalización para acelerar búsquedas */
  private optionsAutoNormalized: Map<string, string> = new Map();

  public chipsList: string[] = [];
  public bdField: string;
  public filteredOptions!: Observable<string[]>;
  /** NUEVO: opciones ya agrupadas por to_group para renderizar sin O(G·N) */
  public filteredGroupedOptions!: Observable<{ group: any; options: string[] }[]>;

  public filteredOptionsLength = 0;
  public filteredOptionsNotShown = 0;

  public myControl = new UntypedFormControl();
  public multiple: boolean;
  public selectable: boolean;
  public removable: boolean;
  public separatorKeysCodes: number[];

  public value: any;
  public valueInit: any;
  public isEmptyValue: boolean;
  public loadedValue: any;
  public loaded = false;
  private subscribeArray: any[] = [];
  public inputValueLabel: string;
  public numCharactersSearch = 0;
  public hasMultiLevel = false;
  private groupNormalizedCache: Map<string, string> = new Map();
  public hasColor = false;
  public arrayGroups: any[] = [];
  public lastQueryLenght = -1;
  public arrayResultsInitial: any[] = [];

  @Output() notifyOthers = new EventEmitter<{}>();

  @ViewChild("chipInput") chipInput!: ElementRef<HTMLInputElement>;
  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;

  constructor(
    public genericService: GenericService,
    public conditionsClientService: ConditionsClientService,
    private endpointService: EndpointService,
    protected dispatcher: Dispatcher,
    private functionsService: FunctionsService,
    private functionsControllerService: FunctionsControllerService
  ) {}

  ngOnInit(): void {
    const sbscr = this.dispatcher.subscribe(this);
    this.subscribeArray.push(sbscr);

    if (
      this.structure[this.index]["tmp_value"] === null ||
      this.structure[this.index]["tmp_value"] === undefined
    )
      this.structure[this.index]["tmp_value"] = "";
    this.loadedValue = this.structure[this.index]["tmp_value"];

    this.bdField = this.structure[this.index]["bd_field"];
    this.genericForm = this.structure[this.index]["form"];
    this.multiple = this.structure[this.index]["multiple"] == 1;

    const results =
      this.genericService.selectOptions[this.structure[this.index]["id_query"]];

    this.genericService.initFormChangeField(this.structure[this.index]);
    this.typeofInitialValue();

    if (this.multiple && !Array.isArray(this.structure[this.index]["tmp_value"])) {
      this.value = [this.structure[this.index]["tmp_value"]];
      if (results && results !== undefined && !results.includes(this.structure[this.index]["tmp_value"])) {
        this.value = null;
      }
      this.isEmptyValue = false;
    } else {
      this.value = this.structure[this.index]["tmp_value"];
      if (this.value === "") this.value = null;
      this.isEmptyValue = false;
    }

    this.selectable = true;
    this.removable = true;
    this.separatorKeysCodes = [ENTER, COMMA];
    this.optionsAutoMap = new Map();
    this.optionsAutoMapGroup = new Map();
    this.optionsAutoMapColors = new Map();

    if (
      this.structure[this.index]["type"] == "radio" ||
      this.structure[this.index]["type"] == "toggle"
    ) {
      if (this.structure[this.index]["id_functional_status_general"] === 5) {
        this.structure[this.index].form.controls[
          this.structure[this.index]["id_functional_area"] + "-" + this.bdField
        ].setValidators([Validators.required]);
      }
      this.structure[this.index].invalid = false;
    }

    if (this.multiple) {
      if (
        this.structure[this.index]["tmp_value"] !== undefined &&
        this.structure[this.index]["tmp_value"] !== null
      )
        this.structure[this.index].originalValue = JSON.parse(
          JSON.stringify(this.structure[this.index]["tmp_value"])
        );
      if (!Array.isArray(this.structure[this.index]["originalValue"]))
        this.structure[this.index]["originalValue"] = [
          this.structure[this.index]["originalValue"],
        ];
      if (
        this.structure[this.index]["tmp_value"] === undefined &&
        this.structure[this.index]["type"] == "autocomplete"
      ) {
        this.structure[this.index]["tmp_value"] = [];
      }
      if (!Array.isArray(this.structure[this.index]["tmp_value"]))
        this.structure[this.index]["tmp_value"] = [];
    }

    if (this.value !== undefined && this.value !== null) {
      this.genericForm.patchValue({
        [this.structure[this.index]["id_functional_area"] + "-" + this.bdField]:
          this.value,
      });
    }

    const susbcr = this.genericService.structureUpdated.subscribe((strc) => {
      for (let key in strc) {
        const elem = this.genericService.findElementWithIdLoop(
          this.genericService.getAllStructures(1),
          this.structure[this.index]["id_functional_area"]
        );
        if (elem) {
          this.value = this.genericService.cloneVariable(
            elem["child"]["tmp_value"]
          );
          if (this.value === "") this.value = null;
          if (this.value) {
            this.genericForm.patchValue({
              [this.structure[this.index]["id_functional_area"] +
              "-" +
              this.bdField]: this.value,
            });
          }

          if (this.structure[this.index]["type"] == "autocomplete") {
            this.myControl.setValue(
              Array.from(this.optionsAutoMap.entries())
                .filter(({ 1: v }) => v == this.value)
                .map(([k]) => k)
            );
          }
        }
      }
    });
    this.subscribeArray.push(susbcr);

    let parent = this.structure[this.index]["id_functional_parent_initial"];

    if (
      this.genericForm &&
      this.genericForm["controls"] &&
      this.genericForm["controls"][
        this.structure[this.index]["id_functional_area"] + "-" + this.bdField
      ]
    ) {
      const vcsbcr =
        this.genericForm["controls"][
          this.structure[this.index]["id_functional_area"] + "-" + this.bdField
        ].valueChanges.subscribe((newToogleValue) => {
          this.typeofInitialValue();
          this.valueInit = this.functionsService.cloneVariable(this.value);
          this.value = this.genericService.cloneVariable(newToogleValue);

          let v: any = null;
          let type = "";
          if (this.structure[this.index]["type"] == "autocomplete") {
            if (this.multiple && Array.isArray(newToogleValue)) {
              v = [];
              for (let i in newToogleValue) {
                this.optionsAutoMap.forEach((key, value) => {
                  if (key == newToogleValue[i] || value == newToogleValue[i])
                    v.push(key);
                });
              }
            } else {
              this.optionsAutoMap.forEach((key, value) => {
                if (key == newToogleValue || value == newToogleValue) v = key;
              });
            }
            type = "autocomplete_";
          } else if (this.structure[this.index]["id_functional_type"] != 15) {
            if (newToogleValue !== undefined) v = newToogleValue;
            else v = undefined;
            type = "selection_";
          }

          let valueInit = "";
          if (
            this.genericService.originalInputsValues[
              this.structure[this.index]["id_functional_area"] + "-" + this.bdField
            ] !== undefined &&
            this.genericService.originalInputsValues[
              this.structure[this.index]["id_functional_area"] + "-" + this.bdField
            ]["value"] !== undefined
          )
            valueInit =
              this.genericService.originalInputsValues[
                this.structure[this.index]["id_functional_area"] +
                "-" +
                this.bdField
              ]["value"];
          else valueInit = this.valueInit;

          if ((v || v == 0) && v !== "" && valueInit !== v) {
            let vold: any = null,
              vnew: any = null,
              voriginal: any = null;
            if (this.genericService.selectOptions[this.idQuery] && type != "autocomplete_") {
              let arrayResults: any[] = [];
              arrayResults = this.genericService.selectOptions[this.idQuery];

              if (this.structure[this.index]["type"] === "radio") {
                type = "radio_";
              }
              if (this.structure[this.index]["type"] === "toggle") {
                type = "toggle_";
              }

              if (!this.multiple) {
                for (let o of arrayResults) {
                  if (o["value"] === valueInit) vold = o["text"];
                  if (o["value"] === v && v !== valueInit) vnew = o["text"];
                  if (vold != null && vnew != null) break;
                }
              } else {
                vold = "";
                vnew = "";
                let oldCount = valueInit !== null ? valueInit.length - 1 : 0;
                let newCount = v.length - 1;
                for (let o of this.genericService.selectOptions[this.idQuery]) {
                  if (valueInit !== null) {
                    for (let g of valueInit) {
                      if (o["value"] === g) {
                        vold = vold + o["text"];
                        if (oldCount > 0) vold = vold + ", ";
                        oldCount--;
                      }
                    }
                  }
                  for (let t of v) {
                    if (o["value"] === t) {
                      vnew = vnew + o["text"];
                      if (newCount > 0) vnew = vnew + ", ";
                      newCount--;
                    }
                  }
                }
              }
            } else {
              type = "autocomplete_";
              voriginal = valueInit;
              if (!this.multiple) {
                vnew = newToogleValue;
                this.optionsAutoMap.forEach((key, value) => {
                  if (key == vnew || value == vnew) {
                    vnew = value;
                  }
                  if (key == voriginal || value == voriginal) {
                    vold = value;
                  }
                });
              } else {
                let vnuevo = this.genericService.cloneVariable(
                  this.structure[this.index]["tmp_value"]
                );
                vold = "";
                vnew = "";
                let oldCount =
                  voriginal !== null && voriginal.length ? voriginal.length - 1 : 0;
                let newCount = vnuevo.length - 1;
                this.optionsAutoMap.forEach((key, value) => {
                  if (voriginal !== null) {
                    for (let vo of voriginal) {
                      if (key == vo || value == vo) {
                        vold = vold + value;
                        if (oldCount > 0) vold = vold + ", ";
                        oldCount--;
                      }
                    }
                  }
                  for (let t of vnuevo) {
                    if (key == t || value == t) {
                      vnew = vnew + value;
                      if (newCount > 0) vnew = vnew + ", ";
                      newCount--;
                    }
                  }
                });
              }
            }

            if (vnew === vold) {
              if (this.structure[this.index]["id_functional_parent_initial_dsb"] > 0)
                parent = this.structure[this.index]["id_functional_parent_initial_dsb"];
              if (
                this.genericService.formsChanged[parent] &&
                this.genericService.formsChanged[parent][
                  this.genericService.paramControlVariables[parent]["indexParam"]
                ]
              ) {
                if (this.structure[this.index]["type"] === "radio") type = "radio_";
                if (this.structure[this.index]["type"] === "toggle") type = "toggle_";
                setTimeout(() => {
                  delete this.genericService.formsChanged[parent][
                    this.genericService.paramControlVariables[parent]["indexParam"]
                  ][type + this.structure[this.index]["id_functional_area"]];
                }, 500);
              }
              this.executeFunction(vnew, type);
            } else {
              let id_parent =
                this.structure[this.index]["origin_duplicated_id_functional_area"];
              if (id_parent === undefined || id_parent === null)
                id_parent = this.structure[this.index]["id_functional_parent"];
              this.functionsControllerService.updateFormHistory(
                this.structure[this.index],
                this.structure[this.index]["id_functional_parent_initial_dsb"],
                parent,
                id_parent,
                this.structure[this.index]["id_functional_area"],
                type,
                vold,
                vnew,
                vold,
                v,
                this.structure[this.index]["label"]
              );
            }
          } else if (valueInit === v) {
            if (this.structure[this.index]["id_functional_parent_initial_dsb"] > 0)
              parent = this.structure[this.index]["id_functional_parent_initial_dsb"];
            if (
              this.genericService.formsChanged[parent] &&
              this.genericService.formsChanged[parent][
                this.genericService.paramControlVariables[parent]["indexParam"]
              ]
            ) {
              if (this.structure[this.index]["type"] === "radio") type = "radio_";
              if (this.structure[this.index]["type"] === "toggle") type = "toggle_";
              setTimeout(() => {
                delete this.genericService.formsChanged[parent][
                  this.genericService.paramControlVariables[parent]["indexParam"]
                ][type + this.structure[this.index]["id_functional_area"]];
              }, 500);
            }
            this.executeFunction(v, type);
          } else if (this.genericService.selectOptions[this.idQuery]) {
            this.clear(this.bdField, 1);
          }

          if (this.structure[this.index]["type"] != "autocomplete") {
            this.structure[this.index]["tmp_value"] = newToogleValue;
          } else {
            if (!this.multiple) {
              let valueNewToggle = newToogleValue;
              this.optionsAutoMap.forEach((key, value) => {
                if (key == valueNewToggle || value == valueNewToggle) {
                  valueNewToggle = key;
                }
              });
              this.structure[this.index]["tmp_value"] = valueNewToggle;
            }
          }
          this.isEmptyValue = false;
        });
      this.subscribeArray.push(vcsbcr);

      const vcfcsbcr =
        this.genericForm["controls"][
          this.structure[this.index]["id_functional_area"] +
            "-" +
            this.structure[this.index]["bd_field"]
        ].valueChanges.subscribe((newValue: any) => {
          this.updateDataValidity(newValue);
        });
      this.subscribeArray.push(vcfcsbcr);
    }

    this.getDisplayedOptions();

    // Filtrado optimizado (debounce + cache normalizada + búsqueda por grupo o texto)
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      debounceTime(120),
      distinctUntilChanged(),
      map((chip) => {
        const raw = chip == null ? "" : (this.normalize(chip) || "").toLowerCase();

        const result = this.optionsAuto.filter((option) => {
          if (option === undefined || option === null) option = "";
          const normalizedOption =
            this.optionsAutoNormalized.get(option) ??
            this.computeAndCacheNormalized(option);
          const matchesText = normalizedOption.includes(raw);

          // Coincidencia por grupo (si el usuario escribe algo del nombre del grupo)
          const groupKey = option + this.optionsAutoMap.get(option);
          const toGroup = this.optionsAutoMapGroup.get(groupKey);
          const matchesGroup =
            !!toGroup &&
            this.computeAndCacheNormalizedGroup(toGroup).includes(raw);

          return matchesText || matchesGroup;
        });

        this.filteredOptionsLength = result.length;

        return this.filteredOptionsLength === 0
          ? result.slice()
          : this.filteredOptionsLength <= 200
          ? result
          : result.slice(0, 200);
      })
    );

    /** NUEVO: agrupamos UNA SOLA VEZ por emisión (evita O(G·N) y múltiples async) */
    this.filteredGroupedOptions = this.filteredOptions.pipe(
      map((list: string[]) => {
        if (!this.hasMultiLevel || !list || list.length === 0) return [];
        const buckets = new Map<any, string[]>();
        for (const option of list) {
          const key = option + this.optionsAutoMap.get(option);
          const tg = this.optionsAutoMapGroup.get(key);
          if (tg === undefined || tg === null || tg === "") continue;
          let arr = buckets.get(tg);
          if (!arr) {
            arr = [];
            buckets.set(tg, arr);
          }
          arr.push(option);
        }
        return Array.from(buckets, ([group, options]) => ({ group, options }));
      })
    );

    if (this.structure[this.index]["type"] == "autocomplete") {
      this.myControl.setValue(
        Array.from(this.optionsAutoMap.entries())
          .filter(({ 1: v }) => v == this.value)
          .map(([k]) => k)
      );
      this.checkTmpValueMultiple();
    }

    this.structure[this.index]["tmp_value"] = this.loadedValue;
    this.loaded = true;

    // Inicializamos valores originales
    this.genericService.setOriginalInputsValues(this.structure, this.index);

    const optionsSubs = this.genericService.selectOptionsChangeEvent.subscribe(
      () => {
        if (this.genericService.selectOptions[this.idQuery])
          this.getDisplayedOptions();
        this.genericService.chooseType(
          this.idQuery,
          this.structure[this.index]
        );
      }
    );
    this.subscribeArray.push(optionsSubs);

    const formFieldsUpdateSubscription =
      this.genericService.updateFormFields.subscribe((change) => {
        if (change) this.value = this.structure[this.index]["tmp_value"];
      });
    this.subscribeArray.push(formFieldsUpdateSubscription);

    this.arrayResultsInitial = this.functionsService.cloneVariable(
      this.genericService.selectOptions[this.idQuery]
    );
  }

  private computeAndCacheNormalized(option: string): string {
    const n = (this.normalize(option) || "").toLowerCase();
    this.optionsAutoNormalized.set(option, n);
    return n;
  }

  private executeFunction(v: any, type: string) {
    if ((v || v == 0) && v !== "") {
      this.functionsControllerService.updateLastValue(
        this.structure[this.index],
        v
      );
      // <-- parent debía declararse aquí (bug original)
      let parent = this.structure[this.index]["id_functional_parent_initial"];
      if (this.structure[this.index]["id_functional_parent_initial_dsb"] > 0) {
        parent = this.structure[this.index]["id_functional_parent_initial_dsb"];
      }
      this.functionsControllerService.executeFunctionFromForm(
        parent,
        this.structure[this.index],
        v,
        null,
        type
      );
    }
  }

  ngAfterViewInit() {
    if (
      this.structure[this.index]["tmp_value"] === undefined ||
      this.structure[this.index]["tmp_value"] === "" ||
      this.structure[this.index]["tmp_value"] === null
    ) {
      this.updateDataValidity(-1);
    } else {
      this.updateDataValidity(this.structure[this.index]["tmp_value"]);
    }
    this.functionsControllerService.getFunctionFormField(
      this.structure[this.index],
      true
    );
  }

  private updateDataValidity(v: any, init = false) {
    if (this.structure[this.index]["type"] == "autocomplete" && !init)
      v = this.optionsAutoMap.get(v);
    let data_validity_value = v;
    if (v === undefined || v === null) {
      if (
        this.structure[this.index]["tmp_value"] === undefined ||
        this.structure[this.index]["tmp_value"] == "" ||
        this.structure[this.index]["tmp_value"] === null
      )
        data_validity_value = -1;
      else data_validity_value = this.structure[this.index]["tmp_value"];
    } else if (v == -999) {
      data_validity_value = -1;
    }
    this.genericService.updateStatus(data_validity_value, this.structure[this.index]);
  }

  chooseEmptySelection(bool: boolean) {
    this.isEmptyValue = !bool;
  }

  searchGetCall(term: string) {
    if (term === "") {
      return of([]);
    }
    const arrayTerm = term.split(" ");
    return this.endpointService.getLocations(arrayTerm, false);
  }

  ngOnDestroy() {
    this.genericService.deleteRequiredInFrom(this.structure[this.index]);
    this.subscribeArray.forEach((subscription) => {
      if (subscription !== undefined) subscription.unsubscribe();
    });
  }

  getDisplayedOptions(): void {
    const filter = {
      bd_table: this.structure[this.index]["bd_table"],
      bd_field:
        this.structure[this.index]["id_functional_area"] +
        "-" +
        this.structure[this.index]["bd_field"],
      id_db: this.structure[this.index]["id_db"],
      id_functional_area: this.structure[this.index]["id_functional_area"],
      window: this.structure[this.index]["window"],
    };
    const filter_data = this.genericService.findFormControl(filter);
    this.idQuery = this.structure[this.index]["id_query"];

    if (this.idQuery !== 0) {
      let data = this.genericService.selectOptions[this.idQuery] || [];

      // Detectamos multinivel mirando TODO el array (robusto)
      this.hasMultiLevel =
        Array.isArray(data) &&
        data.some(
          (r) =>
            r &&
            r.hasOwnProperty("to_group") &&
            r.to_group !== undefined &&
            r.to_group !== null &&
            r.to_group !== ""
        );

      this.hasColor =
        Array.isArray(data) &&
        data.some(
          (r) =>
            r &&
            r.hasOwnProperty("color") &&
            r.color !== undefined &&
            r.color !== null &&
            r.color !== ""
        );

      if (this.genericService.selectOptions[this.idQuery]?.length)
        this.lastQueryLenght = this.functionsService.cloneVariable(
          this.genericService.selectOptions[this.idQuery].length
        );

      // Reset estructuras por carga
      this.arrayGroups = [];
      this.optionsAuto = [];
      this.optionsAutoMap = new Map();
      this.optionsAutoMapGroup = new Map();
      this.optionsAutoMapColors = new Map();
      this.optionsAutoNormalized = new Map();
      this.groupNormalizedCache = new Map();

      // Grupos únicos
      if (this.hasMultiLevel) {
        const groups = new Set<any>();
        for (const d of data) {
          if (d && d.to_group !== undefined && d.to_group !== null) {
            groups.add(d.to_group);
          }
        }
        this.arrayGroups = Array.from(groups);
      }

      // Filtra PK duplicada
      if (this.structure[this.index]["primary_key"] == 1 && data && data.length) {
        data = data.filter((elem: any) => {
          if (filter_data && filter_data.length) {
            for (let i = 0; i < filter_data.length; ++i) {
              if (filter_data[i] && filter_data[i].length) {
                for (let j = 0; j < filter_data[i].length; ++j) {
                  if (elem["value"] == filter_data[i][j]) return false;
                  if (Array.isArray(filter_data[i][j])) {
                    if (elem["value"] == filter_data[i][j][0]) return false;
                  }
                }
              }
            }
          }
          return true;
        });
      }

      if (this.structure[this.index]["type"] === "autocomplete") {
        if (data && data.length) {
          for (const d of data) {
            // saltamos la empty option
            if (!d || d.text == null || d.text === "") continue;

            this.optionsAuto.push(d.text);
            this.optionsAutoMap.set(d.text, d.value);
            if (this.hasMultiLevel)
              this.optionsAutoMapGroup.set(d.text + d.value, d.to_group);
            if (this.hasColor) this.optionsAutoMapColors.set(d.text + d.value, d.color);
            // pre-cache normalizado
            this.computeAndCacheNormalized(d.text);
          }

          this.genericForm.patchValue({ refresh: null });
          this.checkTmpValueMultiple();
        }
      } else if (this.structure[this.index]["type"] === "radio") {
        // sin cambios
      } else if (this.structure[this.index]["type"] === "toggle") {
        // sin cambios
      } else {
        if (this.value == "???") {
          this.value = -1;
          if (this.multiple) this.value = [this.value];
          this.genericForm.patchValue({
            [this.structure[this.index]["id_functional_area"] + "-" + this.bdField]:
              this.value,
          });
        } else if (
          this.structure[this.index]["autoload_selection"] == 1 &&
          data !== undefined &&
          data.length &&
          data.length == 1
        ) {
          if (this.structure[this.index]["multiple"] != 1)
            this.structure[this.index]["tmp_value"] = data[0]["value"];
          else {
            if (this.structure[this.index]["tmp_value"] === undefined || this.structure[this.index]["tmp_value"] === null || !Array.isArray(this.structure[this.index]["tmp_value"])) {
              this.structure[this.index]["tmp_value"] = [];
            }
            this.structure[this.index]["tmp_value"].push(data[0]["value"]);
          }
          this.value = this.structure[this.index]["tmp_value"];
          this.genericForm.patchValue({
            [this.structure[this.index]["id_functional_area"] + "-" + this.bdField]:
              this.value,
          });
        }
      }
    }
  }

  // Filtra arrays para no mostrar la empty option
  filterFunction(arrayToFilter: any[]): any[] {
    if (arrayToFilter == undefined) return arrayToFilter;
    return arrayToFilter.filter((i: any) => i.value !== "");
  }

  private normalize(text: string): string {
    if (text) {
      return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9 ]/g, "");
    } else return text as any;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    if (input) input.value = "";
    this.myControl.setValue(null);
  }

  remove(chip: string): void {
    const index = this.chipsList.indexOf(chip);
    if (index >= 0) {
      this.structure[this.index]["tmp_value"].splice(index, 1);
      this.chipsList.splice(index, 1);
      this.optionsAuto.unshift(chip);
      this.myControl.setValue("");

      let parent = this.structure[this.index]["id_functional_parent_initial"];
      let vnuevo = this.structure[this.index]["tmp_value"];
      let voriginal =
        this.genericService.originalInputsValues[
          this.structure[this.index]["id_functional_area"] + "-" + this.bdField
        ]["value"];
      let vold = "";
      let vnew = "";
      let oldCount =
        voriginal !== null && voriginal.length ? voriginal.length - 1 : 0;
      let newCount = vnuevo.length - 1;

      this.optionsAutoMap.forEach((key, value) => {
        if (voriginal !== null) {
          for (let vo of voriginal) {
            if (key == vo || value == vo) {
              vold = vold + value;
              if (oldCount > 0) vold = vold + ", ";
              oldCount--;
            }
          }
        }
        for (let t of vnuevo) {
          if (key == t || value == t) {
            vnew = vnew + value;
            if (newCount > 0) vnew = vnew + ", ";
            newCount--;
          }
        }
      });

      let type = "autocomplete_";
      if (vnew === vold) {
        if (this.structure[this.index]["id_functional_parent_initial_dsb"] > 0)
          parent = this.structure[this.index]["id_functional_parent_initial_dsb"];
        if (
          this.genericService.formsChanged[parent] &&
          this.genericService.formsChanged[parent][
            this.genericService.paramControlVariables[parent]["indexParam"]
          ] &&
          this.genericService.formsChanged[parent][
            this.genericService.paramControlVariables[parent]["indexParam"]
          ][type + this.structure[this.index]["id_functional_area"]]
        ) {
          let lastValueOnExecuteFunction = undefined;
          if (
            this.genericService.formsChanged &&
            this.genericService.formsChanged[parent] &&
            this.genericService.formsChanged[parent][
              this.genericService.paramControlVariables[parent]["indexParam"]
            ] &&
            this.genericService.formsChanged[parent][
              this.genericService.paramControlVariables[parent]["indexParam"]
            ][type + this.structure[this.index]["id_functional_area"]] &&
            this.genericService.formsChanged[parent][
              this.genericService.paramControlVariables[parent]["indexParam"]
            ][type + this.structure[this.index]["id_functional_area"]][
              "lastValueOnExecuteFunction"
            ] !== undefined
          )
            lastValueOnExecuteFunction =
              this.genericService.formsChanged[parent][
                this.genericService.paramControlVariables[parent]["indexParam"]
              ][type + this.structure[this.index]["id_functional_area"]][
                "lastValueOnExecuteFunction"
              ];
          if (
            this.structure[this.index]["id_function"] > 0 &&
            (lastValueOnExecuteFunction === undefined ||
              lastValueOnExecuteFunction !== vnew)
          )
            this.functionsControllerService.getFunctionFormField(
              this.structure[this.index]
            );
          setTimeout(() => {
            delete this.genericService.formsChanged[parent][
              this.genericService.paramControlVariables[parent]["indexParam"]
            ][type + this.structure[this.index]["id_functional_area"]];
          }, 500);
        }
      } else {
        let id_parent =
          this.structure[this.index]["origin_duplicated_id_functional_area"];
        if (id_parent === undefined || id_parent === null)
          id_parent = this.structure[this.index]["id_functional_parent"];
        this.functionsControllerService.updateFormHistory(
          this.structure[this.index],
          this.structure[this.index]["id_functional_parent_initial_dsb"],
          parent,
          id_parent,
          this.structure[this.index]["id_functional_area"],
          type,
          vold,
          vnew,
          vold,
          voriginal,
          this.structure[this.index]["label"]
        );
      }
    }
  }

  changeRadioValue(event: MatRadioChange) {
    this.structure[this.index]["tmp_value"] = event.value;
    this.structure[this.index].form.controls[
      this.structure[this.index]["id_functional_area"] + "-" + this.bdField
    ].setValue(event.value);
    this.structure[this.index]["invalid"] = false;
  }

  changeToggleValue(event: MatButtonToggleChange) {
    this.structure[this.index]["tmp_value"] = event.value;
    this.structure[this.index].form.controls[
      this.structure[this.index]["id_functional_area"] + "-" + this.bdField
    ].setValue(event.value);
    this.structure[this.index]["invalid"] = false;
  }

  clear(field: string, from = 0) {
    let find = false;
    let parent = this.structure[this.index]["id_functional_parent_initial"];
    if (
      this.genericService.formsChanged[parent] &&
      this.genericService.paramControlVariables[parent]["indexParam"] &&
      this.genericService.formsChanged[parent][
        this.genericService.paramControlVariables[parent]["indexParam"]
      ]
    ) {
      for (let elem in this.genericService.formsChanged[parent][
        this.genericService.paramControlVariables[parent]["indexParam"]
      ]) {
        let type = this.structure[this.index]["type"] + "_";
        if (elem == type + this.structure[this.index]["id_functional_area"]) {
          find = true;
          if (
            this.genericService.formsChanged[parent][
              this.genericService.paramControlVariables[parent]["indexParam"]
            ][elem]["old"] === "-"
          ) {
            if (
              this.structure[this.index]["id_functional_parent_initial_dsb"] > 0
            )
              parent = this.structure[this.index][
                "id_functional_parent_initial_dsb"
              ];
            let lastValueOnExecuteFunction = undefined;
            if (
              this.genericService.formsChanged &&
              this.genericService.formsChanged[parent] &&
              this.genericService.formsChanged[parent][
                this.genericService.paramControlVariables[parent]["indexParam"]
              ] &&
              this.genericService.formsChanged[parent][
                this.genericService.paramControlVariables[parent]["indexParam"]
              ][type + this.structure[this.index]["id_functional_area"]] &&
              this.genericService.formsChanged[parent][
                this.genericService.paramControlVariables[parent]["indexParam"]
              ][type + this.structure[this.index]["id_functional_area"]][
                "lastValueOnExecuteFunction"
              ] !== undefined
            )
              lastValueOnExecuteFunction =
                this.genericService.formsChanged[parent][
                  this.genericService.paramControlVariables[parent]["indexParam"]
                ][type + this.structure[this.index]["id_functional_area"]][
                  "lastValueOnExecuteFunction"
                ];
            if (
              this.structure[this.index]["id_function"] > 0 &&
              (lastValueOnExecuteFunction === undefined ||
                lastValueOnExecuteFunction !== "-")
            )
              this.functionsControllerService.getFunctionFormField(
                this.structure[this.index]
              );
            setTimeout(() => {
              delete this.genericService.formsChanged[parent][
                this.genericService.paramControlVariables[parent]["indexParam"]
              ][type + this.structure[this.index]["id_functional_area"]];
            }, 500);
          } else
            this.functionsControllerService.updateFormHistory(
              this.structure[this.index],
              this.structure[this.index]["id_functional_parent_initial_dsb"],
              parent,
              this.structure[this.index]["id_functional_parent"],
              this.structure[this.index]["id_functional_area"],
              this.structure[this.index]["type"] + "_",
              this.genericService.formsChanged[parent][
                this.genericService.paramControlVariables[parent]["indexParam"]
              ][elem]["old"],
              "-",
              this.value,
              "-",
              this.structure[this.index]["label"]
            );
        }
      }
    }

    if (!find) {
      setTimeout(() => {
        let vold: any,
          voriginal =
            this.genericService.originalInputsValues[
              this.structure[this.index]["id_functional_area"] + "-" + this.bdField
            ]["value"];
        if (from == 1) vold = this.value;
        this.optionsAutoMap.forEach((key, value) => {
          if (key == voriginal || value == voriginal) {
            vold = value;
          }
        });
        this.functionsControllerService.updateFormHistory(
          this.structure[this.index],
          this.structure[this.index]["id_functional_parent_initial_dsb"],
          parent,
          this.structure[this.index]["id_functional_parent"],
          this.structure[this.index]["id_functional_area"],
          this.structure[this.index]["type"] + "_",
          vold,
          "-",
          this.value,
          "-",
          this.structure[this.index]["label"]
        );
      });
    }

    if (from == 0) {
      this.genericForm.value[
        this.structure[this.index]["id_functional_area"] + "-" + field
      ] = "";
      this.myControl.setValue("");
      this.myControl.touched;
      this.value = "";
      if (!this.multiple) this.structure[this.index]["tmp_value"] = "";
      this.structure[this.index]["form"]["controls"][
        this.structure[this.index]["id_functional_area"] + "-" + field
      ].setValue("");
      const element = document.getElementById(field) as HTMLInputElement;
      if (element) element.value = "";
    }
  }

  public notify(data: any) {
    const id_functional_area = data["id_functional_area"];
    if (
      id_functional_area != this.structure[this.index]["id_functional_area"] &&
      data["field"] == this.bdField
    ) {
      this.getDisplayedOptions();
    }
  }

  public saveFirstOption(event: any, auto: any) {
    const firstOption = auto["options"]["first"];
    if (firstOption !== undefined) {
      if (event.target.value != "" && !this.optionsAuto.includes(event.target.value)) {
        this.genericForm.patchValue({
          [this.structure[this.index]["id_functional_area"] + "-" + this.bdField]:
            firstOption["value"],
        });
      }
    } else {
      this.clear(this.bdField);
    }
  }

  public onClick(str: any, event: MouseEvent) {
    event.stopPropagation();
    this.structure[this.index]["isPressingControl"] =
      event !== undefined && (event.ctrlKey || (event as any).metaKey);
    if (
      this.structure[this.index]["id_function_old"] &&
      this.structure[this.index]["id_function_old"] !== undefined
    ) {
      this.structure[this.index]["id_function"] =
        this.functionsService.cloneVariable(
          this.structure[this.index]["id_function_old"]
        );
    }
    this.structure[this.index]["is_function_selection_multiple"] = false;
    this.functionsControllerService.getFunction(str);
  }

  public onClickChipAutocomplete(event: MouseEvent, val: string) {
    event.stopPropagation();
    this.structure[this.index]["isPressingControl"] =
      event !== undefined && (event.ctrlKey || (event as any).metaKey);
    let newVal = -1;
    for (let o of this.arrayResultsInitial) {
      if (o["text"] === val) {
        newVal = o["value"];
        break;
      }
    }
    this.structure[this.index]["tmp_value_multi_chip"] = newVal;
    this.structure[this.index]["param_intern"] = 1;
    this.structure[this.index]["id_function_old"] =
      this.functionsService.cloneVariable(this.structure[this.index]["id_function"]);
    this.structure[this.index]["id_function"] =
      this.structure[this.index]["id_function_selection_multiple"];
    this.structure[this.index]["is_function_selection_multiple"] = true;
    this.structure[this.index]["autoExecuteFunction"] = false;
    this.functionsControllerService.getFunction(this.structure[this.index]);
  }

  public checkIfHasResults(array: any) {
    return array && array !== undefined && Array.isArray(array) && array.length > 0;
  }

  public typeofInitialValue() {
    let results = this.genericService.selectOptions[
      this.structure[this.index]["id_query"]
    ];
    let val: any = null;
    if (results) {
      if (
        results[1] &&
        (results[1]["value"] ||
          results[1]["value"] === 0 ||
          results[1]["value"] === "")
      ) {
        val = results[1]["value"];
      } else if (
        results[0] &&
        (results[0]["value"] ||
          results[0]["value"] === 0 ||
          results[0]["value"] === "")
      ) {
        val = results[0]["value"];
      }
    }
    if (val !== null && val !== undefined) {
      this.structure[this.index]["typeofValues"] = "int";
      if (typeof val === "string") {
        this.structure[this.index]["typeofValues"] = "string";
        if (this.multiple) {
          if (!this.structure[this.index]["tmp_value"])
            this.structure[this.index]["tmp_value"] = [];
          if (!Array.isArray(this.structure[this.index]["tmp_value"]))
            this.structure[this.index]["tmp_value"] = [
              this.structure[this.index]["tmp_value"],
            ];
          for (let i in this.structure[this.index]["tmp_value"]) {
            this.structure[this.index]["tmp_value"][i] =
              this.structure[this.index]["tmp_value"][i].toString();
          }
        } else {
          if (
            this.structure[this.index]["tmp_value"] ||
            this.structure[this.index]["tmp_value"] === 0 ||
            this.structure[this.index]["tmp_value"] === ""
          )
            this.structure[this.index]["tmp_value"] =
              this.structure[this.index]["tmp_value"].toString();
        }
      } else if (typeof val === "number") {
        if (this.multiple) {
          if (!this.structure[this.index]["tmp_value"])
            this.structure[this.index]["tmp_value"] = [];
          if (!Array.isArray(this.structure[this.index]["tmp_value"]))
            this.structure[this.index]["tmp_value"] = [
              this.structure[this.index]["tmp_value"],
            ];
          for (let i in this.structure[this.index]["tmp_value"]) {
            if (
              this.genericService.canConvertToInt(
                this.structure[this.index]["tmp_value"][i]
              )
            )
              this.structure[this.index]["tmp_value"][i] = parseInt(
                this.structure[this.index]["tmp_value"][i]
              );
          }
        } else {
          if (
            this.structure[this.index]["tmp_value"] ||
            this.structure[this.index]["tmp_value"] === 0 ||
            this.structure[this.index]["tmp_value"] === ""
          ) {
            if (
              this.genericService.canConvertToInt(
                this.structure[this.index]["tmp_value"]
              )
            ) {
              this.structure[this.index]["tmp_value"] = parseInt(
                this.structure[this.index]["tmp_value"]
              );
            }
          }
        }
      }
    }
  }

  public onSelectionChange(event: any) {
    if (this.multiple && event.value && event.value.length == 0) {
      this.updateDataValidity(this.structure[this.index]["tmp_value"]);
      this.functionsControllerService.getFunctionFormField(
        this.structure[this.index],
        true
      );
    }
  }

  public addTmpValue(option: string) {
    if (this.multiple) {
      const val = this.optionsAutoMap.get(option);
      if (!this.structure[this.index]["tmp_value"]) {
        this.structure[this.index]["tmp_value"] = [];
      }
      if (!Array.isArray(this.structure[this.index]["tmp_value"])) {
        if (this.structure[this.index]["tmp_value"]) {
          if (this.structure[this.index]["tmp_value"].includes(",")) {
            this.structure[this.index]["tmp_value"] =
              this.structure[this.index]["tmp_value"].split(",");
          } else {
            this.structure[this.index]["tmp_value"] = [
              this.structure[this.index]["tmp_value"],
            ];
          }
        } else {
          this.structure[this.index]["tmp_value"] = [];
        }
      }
      if (!this.structure[this.index]["tmp_value"].includes(val)) {
        this.structure[this.index]["tmp_value"].push(val);
        this.addChip(option);
      }
    } else {
      this.structure[this.index]["tmp_value"] = option;
    }
    this.genericForm.patchValue({
      [this.structure[this.index]["id_functional_area"] + "-" + this.bdField]:
        this.structure[this.index]["tmp_value"],
    });
  }

  checkTmpValueMultiple() {
    if (
      this.multiple &&
      Array.isArray(this.structure[this.index]["tmp_value"])
    ) {
      for (let t in this.structure[this.index]["tmp_value"]) {
        let val = Array.from(this.optionsAutoMap.entries())
          .filter(({ 1: v }) => v == this.structure[this.index]["tmp_value"][t])
          .map(([k]) => k)[0];
        if (val) this.addChip(val);
      }
    }
  }

  addChip(option: string) {
    if (!this.chipsList.includes(option)) this.chipsList.push(option);
    const index = this.optionsAuto.findIndex((opt) => opt == option);
    if (index > -1) this.optionsAuto.splice(index, 1); // fix if index 0
    this.myControl.setValue("");

    const element = document.getElementById(
      this.structure[this.index]["bd_field"]
    ) as HTMLInputElement;
    if (element && element.value) {
      element.value = "";
      element.blur();
    }
    const auto = document.getElementById("autocomplete") as HTMLInputElement;
    if (auto) {
      auto.blur();
    }
  }

  removeChip(event: MouseEvent, chip: any): void {
    event.stopPropagation();
    this.remove(chip);
  }

  // trackBy para listas
  trackByIndex(i: number) {
    return i;
  }
  trackByValue(i: number, item: any) {
    return item?.value ?? i;
  }
  trackByGroupLabel(i: number, g: { group: any; options: string[] }) {
    return g?.group ?? i;
  }
  trackByOptionText(i: number, option: string) {
    return option ?? i;
  }

  private computeAndCacheNormalizedGroup(val: any): string {
    const key = String(val ?? "");
    const cached = this.groupNormalizedCache.get(key);
    if (cached !== undefined) return cached;
    const norm = (this.normalize(key) || "").toLowerCase();
    this.groupNormalizedCache.set(key, norm);
    return norm;
  }
}